import {Component, ElementRef, ViewChild, AfterViewInit, OnInit, OnDestroy} from '@angular/core';
import {Router} from '@angular/router';

import {ToolService} from '../tool.service';

import {AdMessage} from '../../utils/AdMessage';

import {AdDataModel} from '../../models/AdDataModel';

import {faPencilAlt} from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-tool-preview',
  templateUrl: './preview.component.html',
  styleUrls: ['./preview.component.scss']
})
export class PreviewComponent implements AfterViewInit, OnInit, OnDestroy {
  @ViewChild('canvas', {static: true}) canvas: ElementRef;

  previewData: AdDataModel;
  faPencil = faPencilAlt;
  public adMessage;

  constructor(
    public toolService: ToolService,
    public router: Router
  ) {
    this.previewData = this.toolService.adInfo;
  }

  ngOnInit(): Promise<boolean> {
    if ( !this.previewData ) {
      return this.router.navigateByUrl('/', {skipLocationChange: true});
    }
  }

  ngAfterViewInit(): void {
    if ( this.previewData ) {
      this.adMessage = new AdMessage(this.canvas.nativeElement, this.previewData);
    }
  }

  ngOnDestroy(): void {
    this.toolService.previewShowen.next(false);
  }
}
